(function () {
  'use strict';

  var loaderScript = document.currentScript;

  if (!loaderScript || window.__lara11ClerkSearchLoaded) {
    return;
  }

  window.__lara11ClerkSearchLoaded = true;

  var clerkKey = loaderScript.dataset.clerkKey || '';
  var locale = loaderScript.dataset.clerkLocale || document.documentElement.lang || 'it-IT';
  var currency = loaderScript.dataset.clerkCurrency || 'EUR';
  var showCurrencyCode = loaderScript.dataset.clerkCurrencyCodeEnabled === 'true';
  var isDesignMode = loaderScript.dataset.designMode === 'true' || Boolean(window.Shopify && window.Shopify.designMode);

  function getClerkVisitor() {
    if (!window.Lara11ClerkPrivacy || typeof window.Lara11ClerkPrivacy.getVisitor !== 'function') {
      return null;
    }

    return window.Lara11ClerkPrivacy.getVisitor();
  }

  function toArray(value) {
    if (Array.isArray(value)) {
      return value;
    }

    if (!value || typeof value !== 'object') {
      return [];
    }

    return Object.keys(value).map(function (key) {
      return value[key];
    });
  }

  function getDataValue(data, keys) {
    var containers = [data, data && data.response, data && data.results];

    for (var containerIndex = 0; containerIndex < containers.length; containerIndex += 1) {
      var container = containers[containerIndex];

      if (!container || typeof container !== 'object') {
        continue;
      }

      for (var keyIndex = 0; keyIndex < keys.length; keyIndex += 1) {
        if (container[keys[keyIndex]] != null) {
          return container[keys[keyIndex]];
        }
      }
    }

    return null;
  }

  function getOrderedRecords(data, resultKeys, dataKeys) {
    var result = toArray(getDataValue(data, resultKeys));
    var recordData = getDataValue(data, dataKeys);

    if (Array.isArray(recordData)) {
      if (result.length === 0 || typeof result[0] === 'object') {
        return recordData;
      }

      var recordMap = recordData.reduce(function (map, record) {
        if (record && record.id != null) {
          map[String(record.id)] = record;
        }

        return map;
      }, {});

      return result.map(function (id) {
        return recordMap[String(id)];
      }).filter(Boolean);
    }

    if (recordData && typeof recordData === 'object') {
      if (result.length > 0 && typeof result[0] !== 'object') {
        return result.map(function (id) {
          return recordData[id] || recordData[String(id)];
        }).filter(Boolean);
      }

      return toArray(recordData);
    }

    if (result.length > 0 && typeof result[0] === 'object') {
      return result;
    }

    return [];
  }

  function getProducts(data) {
    var products = getOrderedRecords(data, ['result', 'product_ids'], ['product_data', 'products']);

    return products.filter(function (product) {
      return product && typeof product === 'object';
    });
  }

  function getResultCount(data) {
    var value = getDataValue(data, ['count', 'hits', 'total']);
    var count = Number(value);

    return Number.isFinite(count) ? count : getProducts(data).length;
  }

  function getFacets(data) {
    var facets = getDataValue(data, ['facets']);

    return facets && typeof facets === 'object' && !Array.isArray(facets) ? facets : {};
  }

  function normalizeSuggestions(data) {
    var suggestionData = getDataValue(data, ['suggestions', 'query_suggestions', 'result']);
    var suggestions = suggestionData && !Array.isArray(suggestionData) && suggestionData.result != null
      ? toArray(suggestionData.result)
      : toArray(suggestionData);

    return suggestions.map(function (suggestion) {
      if (typeof suggestion === 'string') {
        return { title: suggestion, url: '' };
      }

      if (!suggestion || typeof suggestion !== 'object') {
        return null;
      }

      return {
        title: suggestion.query || suggestion.name || suggestion.title || suggestion.value || '',
        url: suggestion.url || ''
      };
    }).filter(function (suggestion) {
      return suggestion && suggestion.title;
    });
  }

  function normalizeCategories(data) {
    var categoryEndpoint = getDataValue(data, ['categories']);
    var categories = categoryEndpoint && !Array.isArray(categoryEndpoint) && categoryEndpoint.result != null
      ? getOrderedRecords(categoryEndpoint, ['result', 'category_ids'], ['category_data', 'categories', 'data'])
      : getOrderedRecords(data, ['result', 'category_ids', 'categories'], ['category_data', 'categories', 'data']);

    return categories.map(function (category) {
      if (typeof category === 'string') {
        return { title: category, url: '', image: '' };
      }

      if (!category || typeof category !== 'object') {
        return null;
      }

      return {
        title: category.name || category.title || '',
        url: category.url || category.link || '',
        image: category.image || category.image_url || ''
      };
    }).filter(function (category) {
      return category && category.title;
    });
  }

  function normalizePages(data) {
    var pageEndpoint = getDataValue(data, ['pages']);
    var pages = pageEndpoint && !Array.isArray(pageEndpoint) && pageEndpoint.result != null
      ? getOrderedRecords(pageEndpoint, ['result', 'page_ids'], ['page_data', 'data'])
      : getOrderedRecords(data, ['result', 'page_ids', 'pages'], ['page_data', 'pages', 'data']);

    return pages.map(function (page) {
      if (typeof page === 'string') {
        return { title: page, url: '' };
      }

      if (!page || typeof page !== 'object') {
        return null;
      }

      return {
        title: page.title || page.name || '',
        url: page.url || page.link || ''
      };
    }).filter(function (page) {
      return page && page.title;
    });
  }

  function safeUrl(value) {
    if (!value) {
      return '';
    }

    try {
      var url = new URL(value, window.location.origin);

      if (url.protocol === 'http:' || url.protocol === 'https:') {
        if (url.hostname.endsWith('.myshopify.com')) {
          return url.pathname + url.search + url.hash;
        }

        return url.href;
      }
    } catch (error) {
      return '';
    }

    return '';
  }

  function callClerk(api, args) {
    return new Promise(function (resolve) {
      var settled = false;
      var timeout = window.setTimeout(function () {
        finish({});
      }, 8000);

      function finish(response) {
        if (settled) {
          return;
        }

        settled = true;
        window.clearTimeout(timeout);
        resolve(response || {});
      }

      if (typeof window.Clerk !== 'function') {
        finish({});
        return;
      }

      try {
        window.Clerk('call', api, args, finish, function () {
          finish({});
        });
      } catch (error) {
        finish({});
      }
    });
  }

  function searchUrl(root, query) {
    var url = new URL(root.dataset.searchUrl || '/search', window.location.origin);
    url.searchParams.set('q', query);
    return url.href;
  }

  function formatPrice(value) {
    var price = Number(value);

    if (!Number.isFinite(price)) {
      return '';
    }

    var currencyRate = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        currencyDisplay: showCurrencyCode ? 'code' : 'symbol'
      }).format(price * currencyRate);
    } catch (error) {
      return (price * currencyRate).toFixed(2) + ' ' + currency;
    }
  }

  function createPriceList(product, root) {
    var price = Number(product.price);

    if (!Number.isFinite(price)) {
      return null;
    }

    var listPrice = Number(product.list_price);
    var isOnSale = Number.isFinite(listPrice) && listPrice > price;
    var priceList = document.createElement('price-list');
    priceList.className = 'price-list';

    var salePrice = document.createElement('sale-price');
    salePrice.className = (root.dataset.productTitleFont === 'heading' ? 'h6 ' : '') + (isOnSale ? 'text-on-sale' : 'text-subdued');
    salePrice.textContent = formatPrice(price);
    priceList.appendChild(salePrice);

    if (isOnSale && root.dataset.showComparePrice === 'true') {
      var compareAtPrice = document.createElement('compare-at-price');
      compareAtPrice.className = (root.dataset.productTitleFont === 'heading' ? 'h6 ' : '') + 'text-subdued line-through';
      compareAtPrice.textContent = formatPrice(listPrice);
      priceList.appendChild(compareAtPrice);
    }

    return priceList;
  }

  function createSaleBadge(product) {
    var price = Number(product.price);
    var listPrice = Number(product.list_price);

    if (!Number.isFinite(price) || !Number.isFinite(listPrice) || listPrice <= price) {
      return null;
    }

    var badgeList = document.createElement('div');
    badgeList.className = 'badge-list';
    var badge = document.createElement('span');
    badge.className = 'badge badge--on-sale';
    badge.textContent = '-' + Math.round((1 - price / listPrice) * 100) + '%';
    badgeList.appendChild(badge);
    return badgeList;
  }

  function createProductImage(product, className, position, root) {
    var imageUrl = safeUrl(product.image);

    if (!imageUrl) {
      return null;
    }

    var image = document.createElement('img');
    image.className = className;

    if (root.dataset.imageAspect && root.dataset.imageAspect !== 'natural') {
      image.classList.add('aspect-' + root.dataset.imageAspect);
    }

    if (root.dataset.imageFit === 'cover') {
      image.classList.add('object-cover');
    }

    image.src = imageUrl;
    image.alt = product.name || product.title || '';
    image.loading = position < 3 ? 'eager' : 'lazy';
    image.decoding = 'async';
    image.draggable = false;
    return image;
  }

  function markProduct(element, product) {
    if (product.id != null) {
      element.dataset.clerkProductId = String(product.id);
    }
  }

  function createDesktopProductCard(product, position, root) {
    var productUrl = safeUrl(product.url) || '#';
    var productName = product.name || product.title || '';
    var card = document.createElement('article');
    card.className = 'product-card clerk-search__product-card';
    markProduct(card, product);

    var figure = document.createElement('div');
    figure.className = 'product-card__figure';

    if (root.dataset.showSaleBadge === 'true') {
      var saleBadge = createSaleBadge(product);

      if (saleBadge) {
        figure.appendChild(saleBadge);
      }
    }

    var mediaLink = document.createElement('a');
    mediaLink.className = 'product-card__media clerk-search__selectable';
    mediaLink.href = productUrl;
    mediaLink.dataset.instant = '';
    mediaLink.draggable = false;

    var image = createProductImage(product, 'product-card__image product-card__image--primary clerk-search__product-image', position, root);

    if (image) {
      mediaLink.appendChild(image);
    }

    figure.appendChild(mediaLink);
    card.appendChild(figure);

    var info = document.createElement('div');
    info.className = 'product-card__info';
    var outerStack = document.createElement('div');
    outerStack.className = 'v-stack justify-items-center gap-2';
    var vendor = product.brand || product.vendor;

    if (vendor && root.dataset.showVendor === 'true') {
      var vendorElement = document.createElement('p');
      vendorElement.className = 'smallcaps' + (root.dataset.productTitleFont === 'heading' ? ' heading' : '');
      vendorElement.textContent = vendor;
      outerStack.appendChild(vendorElement);
    }

    var details = document.createElement('div');
    details.className = 'v-stack justify-items-center gap-1';
    var title = document.createElement('a');
    title.className = 'product-title clerk-search__selectable' + (root.dataset.productTitleFont === 'heading' ? ' h6' : '');
    title.href = productUrl;
    title.dataset.instant = '';
    title.textContent = productName;

    if (Number(root.dataset.productTitleMaxLines) > 0) {
      title.classList.add('line-clamp');
      title.style.setProperty('--line-clamp-count', root.dataset.productTitleMaxLines);
    }

    details.appendChild(title);

    var priceList = createPriceList(product, root);

    if (priceList) {
      details.appendChild(priceList);
    }

    outerStack.appendChild(details);
    info.appendChild(outerStack);
    card.appendChild(info);
    return card;
  }

  function createMobileProductCard(product, position, root) {
    var productUrl = safeUrl(product.url) || '#';
    var productName = product.name || product.title || '';
    var card = document.createElement('div');
    card.className = 'horizontal-product-card';
    markProduct(card, product);

    var figure = document.createElement('a');
    figure.className = 'horizontal-product-card__figure clerk-search__selectable';
    figure.href = productUrl;
    figure.dataset.instant = '';

    var image = createProductImage(product, 'horizontal-product-card__image clerk-search__product-image', position, root);

    if (image) {
      figure.appendChild(image);
    }

    card.appendChild(figure);

    var info = document.createElement('div');
    info.className = 'horizontal-product-card__info';
    var stack = document.createElement('div');
    stack.className = 'v-stack gap-1 justify-items-start';
    var title = document.createElement('a');
    title.className = 'product-title clerk-search__selectable' + (root.dataset.productTitleFont === 'heading' ? ' h6' : '');
    title.href = productUrl;
    title.dataset.instant = '';
    title.textContent = productName;
    stack.appendChild(title);

    var priceList = createPriceList(product, root);

    if (priceList) {
      stack.appendChild(priceList);
    }

    info.appendChild(stack);
    card.appendChild(info);
    return card;
  }

  function createProductResult(product, position, root) {
    var fragment = document.createDocumentFragment();
    var desktop = document.createElement('div');
    desktop.className = 'md-max:hidden';
    desktop.appendChild(createDesktopProductCard(product, position, root));
    fragment.appendChild(desktop);

    var mobile = document.createElement('div');
    mobile.className = 'md:hidden';
    mobile.appendChild(createMobileProductCard(product, position, root));
    fragment.appendChild(mobile);
    return fragment;
  }

  function createSuggestions(root, suggestions) {
    var resource = document.createElement('div');
    resource.className = 'predictive-search__resource-item';
    var stack = document.createElement('div');
    stack.className = 'v-stack gap-6 sm:gap-8';
    var heading = document.createElement('p');
    heading.className = 'predictive-search__category h6 text-subdued';
    heading.textContent = root.dataset.suggestionsLabel;
    stack.appendChild(heading);

    var list = document.createElement('div');
    list.className = 'predictive-search__suggestions scroll-area bleed md:unbleed';

    suggestions.forEach(function (suggestion) {
      var item = document.createElement('div');
      var link = document.createElement('a');
      link.className = 'link-reverse clerk-search__selectable';
      link.href = safeUrl(suggestion.url) || searchUrl(root, suggestion.title);
      link.dataset.instant = '';
      link.textContent = suggestion.title;
      item.appendChild(link);
      list.appendChild(item);
    });

    stack.appendChild(list);
    resource.appendChild(stack);
    return resource;
  }

  function createProductsPanel(root, products) {
    var stack = document.createElement('div');
    stack.className = 'v-stack gap-8 sm:gap-12';
    var grid = document.createElement('div');
    grid.className = 'predictive-search__products';
    grid.style.setProperty('--product-list-items-per-row', String(products.length));

    products.forEach(function (product, index) {
      grid.appendChild(createProductResult(product, index, root));
    });

    stack.appendChild(grid);

    var buttonWrapper = document.createElement('div');
    buttonWrapper.className = 'justify-self-start sm:justify-self-center';
    var button = document.createElement('button');
    button.type = 'submit';
    button.className = 'button clerk-search__selectable';
    button.setAttribute('form', root.dataset.formId);
    button.textContent = root.dataset.viewAllLabel;
    buttonWrapper.appendChild(button);
    stack.appendChild(buttonWrapper);
    return stack;
  }

  function createCategoriesPanel(root, categories) {
    var grid = document.createElement('div');
    grid.className = 'predictive-search__collections';
    grid.style.setProperty('--collection-list-items-per-row', String(categories.length));

    categories.forEach(function (category) {
      var link = document.createElement('a');
      link.className = 'v-stack gap-3 sm:gap-5 clerk-search__selectable';
      link.href = safeUrl(category.url) || searchUrl(root, category.title);

      var imageUrl = safeUrl(category.image);

      if (imageUrl) {
        var image = document.createElement('img');
        image.className = 'clerk-search__category-image';
        image.src = imageUrl;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        link.appendChild(image);
      }

      var title = document.createElement('span');
      title.className = 'h6 sm:h5';
      title.textContent = category.title;
      link.appendChild(title);
      grid.appendChild(link);
    });

    return grid;
  }

  function createPagesPanel(root, pages) {
    var list = document.createElement('div');
    list.className = 'predictive-search__pages v-stack justify-items-start gap-3';

    pages.forEach(function (page) {
      var item = document.createElement('div');
      var link = document.createElement('a');
      link.className = 'link-reverse clerk-search__selectable';
      link.href = safeUrl(page.url) || searchUrl(root, page.title);
      link.dataset.instant = '';
      link.textContent = page.title;
      item.appendChild(link);
      list.appendChild(item);
    });

    return list;
  }

  function clearTabs(tabs) {
    if (!tabs) {
      return;
    }

    tabs.querySelectorAll('[slot="title"], [slot="content"]').forEach(function (element) {
      element.remove();
    });
    tabs.hidden = true;
  }

  function resetRenderedResults(root) {
    Array.from(root.results.children).forEach(function (element) {
      if (element !== root.tabs) {
        element.remove();
      }
    });
    root.results.className = '';
    clearTabs(root.tabs);
  }

  function createTabs(root, products, categories, pages) {
    var groups = [];

    if (products.length > 0) {
      groups.push({ label: root.dataset.productsLabel, content: createProductsPanel(root, products) });
    }

    if (categories.length > 0) {
      groups.push({ label: root.dataset.categoriesLabel, content: createCategoriesPanel(root, categories) });
    }

    if (pages.length > 0) {
      groups.push({ label: root.dataset.pagesLabel, content: createPagesPanel(root, pages) });
    }

    if (groups.length === 0) {
      return null;
    }

    var tabs = root.tabs;

    if (!tabs) {
      return null;
    }

    groups.forEach(function (group, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'h6';
      button.setAttribute('role', 'tab');
      button.setAttribute('slot', 'title');
      button.textContent = group.label;
      tabs.appendChild(button);

      var panel = document.createElement('div');
      panel.className = 'predictive-search__resource-item';
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('slot', 'content');
      panel.hidden = index !== 0;
      panel.appendChild(group.content);
      tabs.appendChild(panel);
    });

    tabs.hidden = false;
    return tabs;
  }

  function renderNoResults(root) {
    var message = document.createElement('p');
    message.className = 'predictive-search__no-results text-lg';
    message.textContent = root.dataset.noResultsLabel;
    return message;
  }

  function resultsAnnouncement(root, products, categories, pages) {
    var parts = [];

    if (products.length > 0) {
      parts.push(products.length + ' ' + root.dataset.productsLabel);
    }

    if (categories.length > 0) {
      parts.push(categories.length + ' ' + root.dataset.categoriesLabel);
    }

    if (pages.length > 0) {
      parts.push(pages.length + ' ' + root.dataset.pagesLabel);
    }

    return parts.length > 0 ? parts.join(', ') : root.dataset.noResultsLabel;
  }

  function shuffle(values) {
    var result = values.slice();

    for (var index = result.length - 1; index > 0; index -= 1) {
      var randomIndex = Math.floor(Math.random() * (index + 1));
      var current = result[index];
      result[index] = result[randomIndex];
      result[randomIndex] = current;
    }

    return result;
  }

  function getPreviewProducts(root) {
    var source = root.querySelector('[data-clerk-search-preview-products]');

    if (!source) {
      return [];
    }

    try {
      return toArray(JSON.parse(source.textContent));
    } catch (error) {
      return [];
    }
  }

  function getFocusableResults(root) {
    var results = root.querySelector('[data-clerk-search-results]');

    if (!results) {
      return [];
    }

    return Array.prototype.slice.call(results.querySelectorAll('.clerk-search__selectable:not([hidden])')).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  var ClerkPredictiveSearch = class extends HTMLElement {
    constructor() {
      super();
      this.listenersAbortController = null;
      this.loadingTimeout = null;
      this.searchTimeout = null;
      this.requestSequence = 0;
      this.form = null;
      this.input = null;
      this.output = null;
      this.results = null;
      this.tabs = null;
      this.status = null;

      if (!this.shadowRoot) {
        this.attachShadow({ mode: 'open' }).appendChild(document.createRange().createContextualFragment('<slot name="results"></slot>'));
      }
    }

    connectedCallback() {
      this.listenersAbortController = new AbortController();
      this.form = document.querySelector('[aria-owns="' + this.id + '"]');
      this.input = this.form && this.form.elements.q;
      this.output = this.querySelector('[data-clerk-search-output]');
      this.results = this.querySelector('[data-clerk-search-results]');
      this.tabs = this.querySelector('[data-clerk-search-tabs]');
      this.status = this.querySelector('[data-clerk-search-status]');

      if (!this.form || !this.input || !this.output || !this.results || !this.tabs) {
        return;
      }

      this.input.addEventListener('input', this.onInput.bind(this), { signal: this.listenersAbortController.signal });
      this.input.addEventListener('keydown', this.onInputKeydown.bind(this), { signal: this.listenersAbortController.signal });
      this.form.addEventListener('submit', this.onFormSubmit.bind(this), { signal: this.listenersAbortController.signal });
      this.form.addEventListener('reset', this.onReset.bind(this), { signal: this.listenersAbortController.signal });
      this.addEventListener('keydown', this.onResultsKeydown.bind(this), { signal: this.listenersAbortController.signal });
    }

    disconnectedCallback() {
      if (this.listenersAbortController) {
        this.listenersAbortController.abort();
      }

      window.clearTimeout(this.loadingTimeout);
      window.clearTimeout(this.searchTimeout);
    }

    onInput() {
      var query = this.input.value.trim();
      this.requestSequence += 1;
      var requestId = this.requestSequence;

      window.clearTimeout(this.searchTimeout);

      if (!query) {
        this.clear();
        return;
      }

      this.setBusy(true);
      window.clearTimeout(this.loadingTimeout);
      this.loadingTimeout = window.setTimeout(this.setBusy.bind(this, false), 8000);

      this.searchTimeout = window.setTimeout(function () {
        if (isDesignMode) {
          this.renderPreview(query);
        } else {
          this.searchClerk(query, requestId);
        }
      }.bind(this), 280);
    }

    onInputKeydown(event) {
      if (event.key !== 'ArrowDown') {
        return;
      }

      var focusable = getFocusableResults(this);

      if (focusable.length > 0) {
        event.preventDefault();
        focusable[0].focus();
      }
    }

    onResultsKeydown(event) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
        return;
      }

      var focusable = getFocusableResults(this);
      var currentIndex = focusable.indexOf(event.target);

      if (currentIndex === -1) {
        return;
      }

      event.preventDefault();

      if (event.key === 'ArrowUp' && currentIndex === 0) {
        this.input.focus();
        return;
      }

      var nextIndex = event.key === 'ArrowDown' ? currentIndex + 1 : currentIndex - 1;
      focusable[(nextIndex + focusable.length) % focusable.length].focus();
    }

    onFormSubmit(event) {
      if (!this.input.value.trim()) {
        event.preventDefault();
      }
    }

    onReset() {
      window.setTimeout(this.clear.bind(this), 0);
    }

    setBusy(isBusy) {
      this.toggleAttribute('aria-busy', isBusy);

      if (this.output) {
        this.output.toggleAttribute('aria-busy', isBusy);
      }
    }

    setExpanded(isExpanded) {
      this.input.setAttribute('aria-expanded', String(isExpanded));
      this.output.hidden = !isExpanded;
    }

    clear() {
      this.requestSequence += 1;
      window.clearTimeout(this.loadingTimeout);
      window.clearTimeout(this.searchTimeout);
      this.setBusy(false);
      this.setExpanded(false);
      resetRenderedResults(this);

      if (this.status) {
        this.status.textContent = '';
      }
    }

    renderPreview(query) {
      var previewProducts = shuffle(getPreviewProducts(this));
      var suggestionLimit = Number(this.dataset.suggestionsLimit) || 0;
      var suggestions = [query].concat(previewProducts.map(function (product) {
        return product.name || product.title || '';
      })).filter(function (suggestion, index, values) {
        return suggestion && values.indexOf(suggestion) === index;
      }).slice(0, suggestionLimit).map(function (suggestion) {
        return { title: suggestion, url: '' };
      });
      var productsLimit = Number(this.dataset.productsLimit) || 5;
      var products = previewProducts.slice(0, suggestions.length > 0 ? Math.min(productsLimit, 4) : productsLimit);
      var categoryLimit = suggestions.length > 0 ? 4 : 5;
      var categories = previewProducts.slice(0, Math.min(Number(this.dataset.categoriesLimit) || 0, categoryLimit)).map(function (product) {
        return {
          title: product.brand || product.name || product.title,
          url: product.url,
          image: product.image
        };
      });
      var pages = products.slice(0, Number(this.dataset.pagesLimit) || 0).map(function (product) {
        return { title: product.name || product.title, url: product.url };
      });

      this.renderResults(products, suggestions, categories, pages, false);
    }

    searchClerk(query, requestId) {
      var productsLimit = Number(this.dataset.productsLimit) || 5;
      var suggestionsLimit = Number(this.dataset.suggestionsLimit) || 0;
      var categoriesLimit = Number(this.dataset.categoriesLimit) || 0;
      var pagesLimit = Number(this.dataset.pagesLimit) || 0;
      var commonArgs = {
        key: clerkKey,
        query: query,
        language: locale,
        visitor: getClerkVisitor()
      };
      var productArgs = Object.assign({}, commonArgs, {
        limit: productsLimit,
        labels: ['Instant Search'],
        attributes: ['id', 'name', 'url', 'image', 'price', 'list_price', 'brand', 'available']
      });
      var requests = [
        callClerk('search/predictive', productArgs),
        suggestionsLimit > 0 ? callClerk('search/suggestions', Object.assign({}, commonArgs, { limit: suggestionsLimit })) : Promise.resolve({}),
        categoriesLimit > 0 ? callClerk('search/categories', Object.assign({}, commonArgs, { limit: categoriesLimit })) : Promise.resolve({}),
        pagesLimit > 0 ? callClerk('search/pages', Object.assign({}, commonArgs, { limit: pagesLimit })) : Promise.resolve({})
      ];

      Promise.all(requests).then(function (responses) {
        if (!this.isConnected || requestId !== this.requestSequence || this.input.value.trim() !== query) {
          return;
        }

        this.renderClerkResults(responses[0], responses[1], responses[2], responses[3]);
      }.bind(this));
    }

    renderClerkResults(productData, suggestionData, categoryData, pageData) {
      var suggestions = normalizeSuggestions(suggestionData).slice(0, Number(this.dataset.suggestionsLimit) || 0);
      var productsLimit = Number(this.dataset.productsLimit) || 5;
      var products = getProducts(productData).slice(0, suggestions.length > 0 ? Math.min(productsLimit, 4) : productsLimit);
      var categoryLimit = suggestions.length > 0 ? 4 : 5;
      var categories = normalizeCategories(categoryData).slice(0, Math.min(Number(this.dataset.categoriesLimit) || 0, categoryLimit));
      var pages = normalizePages(pageData).slice(0, Number(this.dataset.pagesLimit) || 0);
      this.renderResults(products, suggestions, categories, pages, true);
    }

    renderResults(products, suggestions, categories, pages, trackClicks) {
      window.clearTimeout(this.loadingTimeout);
      this.setBusy(false);
      resetRenderedResults(this);

      if (products.length === 0 && suggestions.length === 0 && categories.length === 0 && pages.length === 0) {
        this.results.insertBefore(renderNoResults(this), this.tabs);
      } else {
        this.results.className = 'predictive-search__results' + (suggestions.length > 0 ? ' predictive-search__results--with-suggestions' : '');

        if (suggestions.length > 0) {
          this.results.insertBefore(createSuggestions(this, suggestions), this.tabs);
        }

        createTabs(this, products, categories, pages);
      }

      this.setExpanded(true);

      if (this.status) {
        this.status.textContent = resultsAnnouncement(this, products, categories, pages);
      }

      if (trackClicks && typeof window.Clerk === 'function') {
        window.Clerk('click', '#' + this.output.id + ' [data-clerk-product-id]');
      }
    }
  };

  var ClerkSearchPage = class extends HTMLElement {
    constructor() {
      super();
      this.listenersAbortController = null;
      this.requestSequence = 0;
      this.query = '';
      this.page = 1;
      this.sort = 'relevance';
      this.selectedFacets = {};
      this.facetLabels = {};
      this.facetTypes = {};
      this.facetAttributes = [];
      this.currentResultCount = 0;
      this.products = null;
      this.summary = null;
      this.status = null;
      this.loading = null;
      this.empty = null;
      this.pagination = null;
      this.toolbar = null;
      this.content = null;
      this.activeFilters = null;
      this.filterContainers = [];
      this.sortButtonLabel = null;
      this.sortOptions = [];
      this.fallback = null;
    }

    connectedCallback() {
      this.listenersAbortController = new AbortController();
      this.products = this.querySelector('[data-clerk-search-page-products]');
      this.summary = this.querySelector('[data-clerk-search-summary]');
      this.status = this.querySelector('[data-clerk-search-page-status]');
      this.loading = this.querySelector('[data-clerk-search-loading]');
      this.empty = this.querySelector('[data-clerk-search-page-empty]');
      this.pagination = this.querySelector('[data-clerk-search-pagination]');
      this.toolbar = this.querySelector('[data-clerk-search-toolbar]');
      this.content = this.querySelector('[data-clerk-search-page-content]');
      this.activeFilters = this.querySelector('[data-clerk-active-filters]');
      this.filterContainers = Array.prototype.slice.call(this.querySelectorAll('[data-clerk-filters]'));
      this.sortButtonLabel = this.querySelector('[data-clerk-sort-button-label]');
      this.sortOptions = Array.prototype.slice.call(this.querySelectorAll('[data-clerk-sort-option]'));
      this.fallback = document.getElementById(this.dataset.fallbackId);
      this.facetAttributes = (this.dataset.facetAttributes || '').split(',').map(function (attribute) {
        return attribute.trim();
      }).filter(function (attribute) {
        return /^[a-zA-Z0-9_.]+$/.test(attribute);
      });

      if (!this.products || !this.summary || !this.status || !this.loading || !this.empty || !this.pagination || !this.content) {
        return;
      }

      this.readStateFromUrl();
      this.addEventListener('change', this.onChange.bind(this), { signal: this.listenersAbortController.signal });
      this.addEventListener('click', this.onClick.bind(this), { signal: this.listenersAbortController.signal });
      window.addEventListener('popstate', this.onPopState.bind(this), { signal: this.listenersAbortController.signal });

      this.syncSortControls();

      if (isDesignMode) {
        this.query = this.query || this.dataset.previewQuery || 'Preview';
        this.content.hidden = false;
        this.renderPreview();
      } else if (this.query) {
        this.content.hidden = false;
        this.search();
      } else {
        this.setBusy(false);
      }
    }

    disconnectedCallback() {
      this.requestSequence += 1;

      if (this.listenersAbortController) {
        this.listenersAbortController.abort();
      }
    }

    readStateFromUrl() {
      var url = new URL(window.location.href);
      var page = Number(url.searchParams.get('page'));
      var allowedSorts = ['relevance', 'price_asc', 'price_desc', 'name_asc', 'name_desc'];
      var requestedSort = url.searchParams.get('clerk_sort') || 'relevance';
      this.query = (url.searchParams.get('q') || this.dataset.query || '').trim();
      this.page = Number.isInteger(page) && page > 0 ? page : 1;
      this.sort = allowedSorts.indexOf(requestedSort) !== -1 ? requestedSort : 'relevance';
      this.selectedFacets = {};

      this.facetAttributes.forEach(function (attribute) {
        var values = url.searchParams.getAll('clerk.' + attribute).filter(Boolean);

        if (values.length > 0) {
          this.selectedFacets[attribute] = values;
        }
      }.bind(this));
    }

    writeStateToUrl(mode) {
      var url = new URL(window.location.href);
      url.searchParams.set('q', this.query);

      if (this.page > 1) {
        url.searchParams.set('page', String(this.page));
      } else {
        url.searchParams.delete('page');
      }

      if (this.sort !== 'relevance') {
        url.searchParams.set('clerk_sort', this.sort);
      } else {
        url.searchParams.delete('clerk_sort');
      }

      this.facetAttributes.forEach(function (attribute) {
        url.searchParams.delete('clerk.' + attribute);
        (this.selectedFacets[attribute] || []).forEach(function (value) {
          url.searchParams.append('clerk.' + attribute, value);
        });
      }.bind(this));

      window.history[mode === 'replace' ? 'replaceState' : 'pushState']({}, '', url);
    }

    onPopState() {
      this.readStateFromUrl();

      this.syncSortControls();

      this.search();
    }

    onChange(event) {
      var facetInput = event.target.closest('[data-clerk-facet]');

      if (!facetInput) {
        return;
      }

      var attribute = facetInput.dataset.clerkFacet;
      var value = facetInput.value;
      var selectedValues = (this.selectedFacets[attribute] || []).slice();
      var valueIndex = selectedValues.indexOf(value);

      if (facetInput.checked && valueIndex === -1) {
        selectedValues.push(value);
      } else if (!facetInput.checked && valueIndex !== -1) {
        selectedValues.splice(valueIndex, 1);
      }

      if (selectedValues.length > 0) {
        this.selectedFacets[attribute] = selectedValues;
      } else {
        delete this.selectedFacets[attribute];
      }

      this.page = 1;
      this.writeStateToUrl('push');
      this.search({ scrollToResults: false });
    }

    onClick(event) {
      var sortOption = event.target.closest('[data-clerk-sort-option]');

      if (sortOption) {
        event.preventDefault();

        if (sortOption.value !== this.sort) {
          this.sort = sortOption.value;
          this.page = 1;
          this.syncSortControls();
          this.writeStateToUrl('push');
          this.search({ scrollToResults: true });
        }

        return;
      }

      var paginationButton = event.target.closest('[data-clerk-page]');

      if (paginationButton) {
        event.preventDefault();
        var page = Number(paginationButton.dataset.clerkPage);

        if (Number.isInteger(page) && page > 0 && page !== this.page) {
          this.page = page;
          this.writeStateToUrl('push');
          this.search({ scrollToResults: true });
        }

        return;
      }

      var loadMoreButton = event.target.closest('[data-clerk-load-more]');

      if (loadMoreButton) {
        event.preventDefault();
        this.page += 1;
        this.writeStateToUrl('replace');
        this.search({ append: true });
        return;
      }

      var removeFilterButton = event.target.closest('[data-clerk-remove-filter]');

      if (removeFilterButton) {
        event.preventDefault();
        this.removeFilter(removeFilterButton.dataset.clerkFacet, removeFilterButton.dataset.clerkRemoveFilter);
        return;
      }

      if (event.target.closest('[data-clerk-clear-filters]')) {
        event.preventDefault();
        this.selectedFacets = {};
        this.page = 1;
        this.writeStateToUrl('push');
        this.search({ scrollToResults: true });
        return;
      }

      var showMoreButton = event.target.closest('[data-clerk-show-facet-values]');

      if (showMoreButton) {
        event.preventDefault();
        var accordion = showMoreButton.closest('accordion-disclosure');
        accordion.querySelectorAll('[data-clerk-extra-facet-value]').forEach(function (element) {
          element.hidden = false;
          element.removeAttribute('data-clerk-extra-facet-value');
        });
        showMoreButton.hidden = true;
      }
    }

    removeFilter(attribute, value) {
      var values = (this.selectedFacets[attribute] || []).filter(function (selectedValue) {
        return selectedValue !== value;
      });

      if (values.length > 0) {
        this.selectedFacets[attribute] = values;
      } else {
        delete this.selectedFacets[attribute];
      }

      this.page = 1;
      this.writeStateToUrl('push');
      this.search({ scrollToResults: true });
    }

    syncSortControls() {
      var selectedOption = null;

      this.sortOptions.forEach(function (option) {
        var isSelected = option.value === this.sort;
        option.setAttribute('aria-selected', isSelected ? 'true' : 'false');

        if (isSelected) {
          selectedOption = option;
        }
      }.bind(this));

      if (this.sortButtonLabel && selectedOption) {
        this.sortButtonLabel.textContent = selectedOption.dataset.clerkSortLabel || selectedOption.textContent.trim();
      }

      if (selectedOption && selectedOption.id) {
        selectedOption.closest('x-listbox')?.setAttribute('aria-activedescendant', selectedOption.id);
      }
    }

    search(options) {
      options = options || {};
      this.requestSequence += 1;
      var requestId = this.requestSequence;
      var limit = Math.max(1, Number(this.dataset.productsPerPage) || 24);
      var args = {
        key: clerkKey,
        query: this.query,
        limit: limit,
        offset: (this.page - 1) * limit,
        visitor: getClerkVisitor(),
        language: locale,
        labels: ['Search Page'],
        attributes: ['id', 'name', 'url', 'image', 'price', 'list_price', 'brand', 'vendor', 'available']
      };

      if (this.facetAttributes.length > 0 && this.dataset.showFilters === 'true') {
        args.facets = this.facetAttributes;
      }

      var filter = this.buildFilter();

      if (filter) {
        args.filter = filter;
      }

      var sortArgs = this.getSortArgs();

      if (sortArgs) {
        args.orderby = sortArgs.orderby;
        args.order = sortArgs.order;
      }

      this.setBusy(true, options.append);

      callClerk('search/search', args).then(function (response) {
        if (!this.isConnected || requestId !== this.requestSequence) {
          return;
        }

        if (!this.isSuccessfulResponse(response)) {
          this.showFallback();
          return;
        }

        this.renderResponse(response, options);
      }.bind(this));
    }

    isSuccessfulResponse(response) {
      return Boolean(response && (response.status === 'ok' || response.count != null || response.hits != null || Array.isArray(response.result)));
    }

    getSortArgs() {
      var parts = this.sort.split('_');

      if ((parts[0] === 'price' || parts[0] === 'name') && (parts[1] === 'asc' || parts[1] === 'desc')) {
        return { orderby: parts[0], order: parts[1] };
      }

      return null;
    }

    buildFilter() {
      var groups = [];

      this.facetAttributes.forEach(function (attribute) {
        var values = this.selectedFacets[attribute] || [];

        if (values.length === 0) {
          return;
        }

        var isRange = this.facetTypes[attribute] === 'range' || attribute === 'price' || attribute === '_price_range';

        if (isRange) {
          var ranges = values.map(function (value) {
            var bounds = value.split(':').map(Number);

            if (bounds.length !== 2 || !Number.isFinite(bounds[0]) || !Number.isFinite(bounds[1])) {
              return '';
            }

            return '(' + attribute + ' >= ' + bounds[0] + ' and ' + attribute + ' <= ' + bounds[1] + ')';
          }).filter(Boolean);

          if (ranges.length > 0) {
            groups.push('(' + ranges.join(' or ') + ')');
          }

          return;
        }

        var serializedValues = values.map(function (value) {
          if (attribute === 'categories' && /^-?\d+(\.\d+)?$/.test(value)) {
            return value;
          }

          return JSON.stringify(value);
        });
        groups.push(attribute + ' in [' + serializedValues.join(',') + ']');
      }.bind(this));

      return groups.join(' and ');
    }

    setBusy(isBusy, append) {
      this.setAttribute('aria-busy', isBusy ? 'true' : 'false');

      if (isBusy) {
        this.loading.hidden = Boolean(append || this.products.childElementCount > 0);
        this.empty.hidden = true;
      } else {
        this.loading.hidden = true;
      }
    }

    showFallback() {
      this.setBusy(false);
      this.hidden = true;

      if (this.fallback) {
        this.fallback.hidden = false;
      }

      console.warn('Clerk search was unavailable. Shopify search results are being shown instead.');
    }

    renderResponse(response, options) {
      options = options || {};
      var products = getProducts(response);
      var resultCount = getResultCount(response);
      var facets = getFacets(response);

      if (!options.append && products.length === 0 && resultCount > 0 && this.page > 1) {
        this.page = 1;
        this.writeStateToUrl('replace');
        this.search(options);
        return;
      }

      this.currentResultCount = resultCount;
      this.updateFacetMetadata(facets);
      this.renderProducts(products, Boolean(options.append));
      this.renderFacets(facets);
      this.renderActiveFilters();
      this.renderPagination(resultCount);
      this.renderSummary(resultCount);
      this.setBusy(false);
      if (this.toolbar) {
        this.toolbar.hidden = resultCount === 0 || (this.dataset.showFilters !== 'true' && this.dataset.showSortBy !== 'true');
      }
      this.products.hidden = resultCount === 0;
      this.empty.hidden = resultCount !== 0;

      if (options.scrollToResults) {
        this.querySelector('.clerk-search-page__collection')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      if (typeof window.Clerk === 'function' && this.products.id) {
        window.Clerk('click', '#' + this.products.id + ' [data-clerk-product-id]');
      }
    }

    renderProducts(products, append) {
      var fragment = document.createDocumentFragment();

      products.forEach(function (product, index) {
        fragment.appendChild(createDesktopProductCard(product, index, this));
      }.bind(this));

      if (append) {
        this.products.appendChild(fragment);
      } else {
        this.products.replaceChildren(fragment);
      }
    }

    renderSummary(resultCount) {
      var decoder = document.createElement('textarea');
      decoder.innerHTML = this.dataset.resultsSummaryTemplate || '__COUNT__ products for "__TERMS__"';
      var text = decoder.value
        .split('__COUNT__').join(String(resultCount))
        .split('__TERMS__').join(this.query);
      this.summary.textContent = text;
      this.summary.hidden = false;
      this.status.textContent = text;
    }

    updateFacetMetadata(facets) {
      this.facetAttributes.forEach(function (attribute) {
        var values = toArray(facets[attribute]);
        this.facetLabels[attribute] = this.facetLabels[attribute] || {};

        values.forEach(function (facet) {
          var token = this.getFacetToken(facet);

          if (!token) {
            return;
          }

          this.facetTypes[attribute] = facet.type || this.facetTypes[attribute] || 'unit';
          this.facetLabels[attribute][token] = this.getFacetValueLabel(facet);
        }.bind(this));
      }.bind(this));
    }

    getFacetToken(facet) {
      if (!facet || typeof facet !== 'object') {
        return '';
      }

      if (facet.type === 'range') {
        return String(facet.min) + ':' + String(facet.max);
      }

      return facet.value == null ? '' : String(facet.value);
    }

    getFacetValueLabel(facet) {
      if (facet.type === 'range' && Number.isFinite(Number(facet.min)) && Number.isFinite(Number(facet.max))) {
        return formatPrice(facet.min) + ' – ' + formatPrice(facet.max);
      }

      return String(facet.name || facet.value || '');
    }

    getFacetTitle(attribute) {
      var knownTitles = {
        price: this.dataset.facetPriceLabel,
        _price_range: this.dataset.facetPriceLabel,
        categories: this.dataset.facetCategoriesLabel,
        vendor: this.dataset.facetVendorLabel,
        brand: this.dataset.facetVendorLabel
      };

      if (knownTitles[attribute]) {
        return knownTitles[attribute];
      }

      return attribute.replace(/[_.-]+/g, ' ').replace(/\b\w/g, function (character) {
        return character.toUpperCase();
      });
    }

    renderFacets(facets) {
      if (this.dataset.showFilters !== 'true') {
        return;
      }

      this.filterContainers.forEach(function (container, containerIndex) {
        var list = document.createElement('div');
        list.className = 'accordion-list';

        this.facetAttributes.forEach(function (attribute) {
          var values = toArray(facets[attribute]);
          var selectedValues = this.selectedFacets[attribute] || [];

          if (values.length === 0 && selectedValues.length === 0) {
            return;
          }

          var accordion = this.createFacetGroup(attribute, values, selectedValues, containerIndex);

          if (accordion) {
            list.appendChild(accordion);
          }
        }.bind(this));

        container.replaceChildren(list);
      }.bind(this));

      var activeCount = Object.keys(this.selectedFacets).reduce(function (count, attribute) {
        return count + this.selectedFacets[attribute].length;
      }.bind(this), 0);
      var buttonLabel = this.dataset.filterButtonLabel || this.dataset.filtersLabel || 'Filters';
      this.querySelectorAll('[data-clerk-filter-button-text]').forEach(function (element) {
        element.textContent = buttonLabel + (activeCount > 0 ? ' (' + activeCount + ')' : '');
      });
    }

    createFacetGroup(attribute, values, selectedValues, containerIndex) {
      var accordion = document.createElement('accordion-disclosure');
      accordion.className = 'accordion';
      var details = document.createElement('details');
      details.className = 'accordion__disclosure group';
      details.setAttribute('aria-expanded', 'false');

      if (this.dataset.openFiltersByDefault === 'true' || selectedValues.length > 0) {
        details.open = true;
        details.setAttribute('aria-expanded', 'true');
      }

      var summary = document.createElement('summary');
      var toggle = document.createElement('span');
      toggle.className = 'accordion__toggle h6';
      var title = document.createElement('span');
      title.textContent = this.getFacetTitle(attribute);
      var plus = document.createElement('span');
      plus.className = 'animated-plus group-expanded:rotate';
      plus.setAttribute('aria-hidden', 'true');
      toggle.append(title, plus);
      summary.appendChild(toggle);
      details.appendChild(summary);

      var content = document.createElement('div');
      content.className = 'accordion__content';
      var valueList = document.createElement('div');
      valueList.className = 'clerk-search-page__facet-values';
      var visibleLimit = Math.max(1, Number(this.dataset.facetValuesLimit) || 10);
      var displayedTokens = [];

      values.forEach(function (facet, valueIndex) {
        var token = this.getFacetToken(facet);

        if (!token || displayedTokens.indexOf(token) !== -1) {
          return;
        }

        displayedTokens.push(token);
        valueList.appendChild(this.createFacetValue(attribute, facet, token, selectedValues, containerIndex, valueIndex, valueIndex >= visibleLimit));
      }.bind(this));

      selectedValues.forEach(function (token, selectedIndex) {
        if (displayedTokens.indexOf(token) !== -1) {
          return;
        }

        var fallbackFacet = {
          type: this.facetTypes[attribute] || 'unit',
          value: token,
          name: this.facetLabels[attribute]?.[token] || token,
          count: 0
        };

        if (fallbackFacet.type === 'range') {
          var bounds = token.split(':').map(Number);
          fallbackFacet.min = bounds[0];
          fallbackFacet.max = bounds[1];
        }

        valueList.appendChild(this.createFacetValue(attribute, fallbackFacet, token, selectedValues, containerIndex, values.length + selectedIndex, false));
      }.bind(this));

      content.appendChild(valueList);

      if (values.length > visibleLimit) {
        var moreButton = document.createElement('button');
        moreButton.type = 'button';
        moreButton.className = 'link text-sm clerk-search-page__facet-more';
        moreButton.dataset.clerkShowFacetValues = '';
        moreButton.textContent = this.dataset.showMoreLabel || 'Show more';
        content.appendChild(moreButton);
      }

      details.appendChild(content);
      accordion.appendChild(details);
      return accordion;
    }

    createFacetValue(attribute, facet, token, selectedValues, containerIndex, valueIndex, isExtra) {
      var row = document.createElement('div');
      row.className = 'checkbox-control clerk-search-page__facet-value';
      var isSelected = selectedValues.indexOf(token) !== -1;

      if (isExtra && !isSelected) {
        row.hidden = true;
        row.dataset.clerkExtraFacetValue = '';
      }

      var input = document.createElement('input');
      var inputId = this.id + '-facet-' + containerIndex + '-' + attribute.replace(/[^a-zA-Z0-9_-]/g, '-') + '-' + valueIndex;
      input.id = inputId;
      input.type = 'checkbox';
      input.className = 'dot-checkbox';
      input.name = 'clerk.' + attribute;
      input.value = token;
      input.checked = isSelected;
      input.dataset.clerkFacet = attribute;

      var label = document.createElement('label');
      label.htmlFor = inputId;
      label.textContent = this.getFacetValueLabel(facet) + (this.dataset.showFilterValuesCount === 'true' ? ' (' + (Number(facet.count) || 0) + ')' : '');
      row.append(input, label);
      return row;
    }

    renderActiveFilters() {
      if (!this.activeFilters) {
        return;
      }

      var fragment = document.createDocumentFragment();
      var activeCount = 0;

      this.facetAttributes.forEach(function (attribute) {
        (this.selectedFacets[attribute] || []).forEach(function (value) {
          activeCount += 1;
          var facet = document.createElement('div');
          facet.className = 'removable-facet';
          var removeButton = document.createElement('button');
          removeButton.type = 'button';
          removeButton.className = 'tap-area link-faded clerk-search-page__active-filter-button';
          removeButton.dataset.clerkFacet = attribute;
          removeButton.dataset.clerkRemoveFilter = value;
          var valueLabel = this.facetLabels[attribute]?.[value] || value;
          removeButton.setAttribute('aria-label', (this.dataset.removeFilterLabelTemplate || 'Remove filter "__NAME__"').split('__NAME__').join(valueLabel));
          removeButton.textContent = '×';
          var label = document.createElement('span');
          label.className = 'text-subdued';
          label.textContent = this.facetLabels[attribute]?.[value] || value;
          facet.append(removeButton, label);
          fragment.appendChild(facet);
        }.bind(this));
      }.bind(this));

      if (activeCount > 1) {
        var clearButton = document.createElement('button');
        clearButton.type = 'button';
        clearButton.className = 'facets-clear-all text-subdued link';
        clearButton.dataset.clerkClearFilters = '';
        clearButton.textContent = this.dataset.clearFiltersLabel || 'Clear all';
        fragment.appendChild(clearButton);
      }

      this.activeFilters.replaceChildren(fragment);
      this.activeFilters.hidden = activeCount === 0;
    }

    renderPagination(resultCount) {
      var pageSize = Math.max(1, Number(this.dataset.productsPerPage) || 24);
      var totalPages = Math.max(1, Math.ceil(resultCount / pageSize));

      if (this.dataset.paginationStyle === 'load_more') {
        if (this.page * pageSize >= resultCount) {
          this.pagination.replaceChildren();
          return;
        }

        var loadMore = document.createElement('button');
        loadMore.type = 'button';
        loadMore.className = 'button';
        loadMore.dataset.clerkLoadMore = '';
        loadMore.textContent = this.dataset.loadMoreLabel || 'Load more';
        this.pagination.replaceChildren(loadMore);
        return;
      }

      if (totalPages <= 1) {
        this.pagination.replaceChildren();
        return;
      }

      var nav = document.createElement('nav');
      nav.className = 'pagination';
      nav.setAttribute('role', 'navigation');
      nav.setAttribute('aria-label', this.dataset.paginationLabel || 'Pagination');

      if (this.page > 1) {
        nav.appendChild(this.createPaginationButton(this.page - 1, 'previous'));
      }

      this.getVisiblePages(totalPages).forEach(function (page) {
        if (page === 'ellipsis') {
          var ellipsis = document.createElement('span');
          ellipsis.className = 'pagination__link pagination__link--disabled h6';
          ellipsis.textContent = '…';
          nav.appendChild(ellipsis);
        } else {
          nav.appendChild(this.createPaginationButton(page));
        }
      }.bind(this));

      if (this.page < totalPages) {
        nav.appendChild(this.createPaginationButton(this.page + 1, 'next'));
      }

      this.pagination.replaceChildren(nav);
    }

    getVisiblePages(totalPages) {
      var pages = [];

      for (var page = 1; page <= totalPages; page++) {
        if (page === 1 || page === totalPages || Math.abs(page - this.page) <= 1) {
          pages.push(page);
        }
      }

      return pages.reduce(function (result, page, index) {
        if (index > 0 && page - pages[index - 1] > 1) {
          result.push('ellipsis');
        }

        result.push(page);
        return result;
      }, []);
    }

    createPaginationButton(page, direction) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'pagination__link h6';
      button.dataset.clerkPage = String(page);
      button.setAttribute('aria-label', (this.dataset.pageLabelTemplate || 'Go to page __PAGE__').split('__PAGE__').join(String(page)));

      if (page === this.page && !direction) {
        button.setAttribute('aria-current', 'page');
      }

      if (direction) {
        var template = this.querySelector('[data-clerk-pagination-' + direction + '-icon]');

        if (template) {
          button.appendChild(template.content.cloneNode(true));
        }
      } else {
        button.textContent = String(page);
      }

      return button;
    }

    renderPreview() {
      var products = getPreviewProducts(this);
      var vendors = {};
      var priceBuckets = {};

      products.forEach(function (product) {
        if (product.vendor) {
          vendors[product.vendor] = (vendors[product.vendor] || 0) + 1;
        }

        var price = Number(product.price);

        if (Number.isFinite(price)) {
          var min = Math.floor(price / 20) * 20;
          var key = min + ':' + (min + 20);
          priceBuckets[key] = (priceBuckets[key] || 0) + 1;
        }
      });

      var facets = {
        vendor: Object.keys(vendors).map(function (vendor) {
          return { type: 'unit', name: vendor, value: vendor, count: vendors[vendor] };
        }),
        price: Object.keys(priceBuckets).map(function (range) {
          var bounds = range.split(':').map(Number);
          return { type: 'range', name: range, min: bounds[0], max: bounds[1], count: priceBuckets[range] };
        })
      };
      var limit = Math.max(1, Number(this.dataset.productsPerPage) || 24);
      var response = {
        status: 'ok',
        count: products.length,
        result: products.slice(0, limit).map(function (product) { return product.id; }),
        product_data: products.slice(0, limit),
        facets: facets
      };
      this.renderResponse(response, {});
    }
  };

  function defineSearchElement() {
    if (!window.customElements.get('clerk-predictive-search')) {
      window.customElements.define('clerk-predictive-search', ClerkPredictiveSearch);
    }

    if (!window.customElements.get('clerk-search-page')) {
      window.customElements.define('clerk-search-page', ClerkSearchPage);
    }
  }

  function initialize() {
    defineSearchElement();
  }

  initialize();
})();
